import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { Card } from '../Card';

export const ModalCard = ({ className, children }) => (
  <Card className={classNames(styles.modalCard, className)}>
    {children}
  </Card>
);
